const brands = [
  { name: 'royal', id: 'rcl', domains: ['royal', 'rcl', 'localhost'], ldBrand: 'ROYAL' },
  { name: 'celebrity', id: 'cel', domains: ['cel', '0.0.0.0'], ldBrand: 'CELEBRITY' },
];
const getBrand = () => {
  const host = window.location.hostname || 'unknown';
  return brands.find((brand) => brand.domains.some((domain) => host.includes(domain))) || brands[0];
};

export default getBrand;
